import classNames from 'classnames'
import { useEffect, useRef } from 'react'

import { getSanitizedHtml } from '@src/quince-site-common/src/utils/getSanitizedHtml'
import removeTargetAttributeForHashAnchorTags from '@src/quince-site-common/src/utils/removeTargetAttributeForHashAnchorTags'
import ProductDetailsIconSection from '@src/quince-site-pdp/src/atoms/productDetailsIcon/product-details-icon-section'
import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackEvent } from '@src/telemetry/track'
import { convertRelativeToAbsoluteUrls } from '@src/utils/general.utils'

import styles from './product-description.module.scss'

import type { ProductDescriptionProps } from './product-description.types'

export const ProductDescriptionLegacy = ({
  description,
  productDetailsIcons,
  showReadMoreInDesc,
  isB2BMode,
}: ProductDescriptionProps) => {
  const productFormContentRef = useRef<HTMLDivElement>(null)
  const productDescription = isB2BMode ? convertRelativeToAbsoluteUrls(description) : description

  useEffect(() => {
    removeTargetAttributeForHashAnchorTags(productFormContentRef.current)
  }, [])

  useEffect(() => {
    if (!productFormContentRef.current) return

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            trackEvent(TELEMETRY_EVENT_NAMES.PRODUCT_SUMMARY_IS_VISIBLE, {
              // eslint-disable-next-line i18next/no-literal-string
              entity_type: 'action',
              entity_id: 'product_summary',
            })
            observer.disconnect()
          }
        })
      },
      { threshold: 0.2 },
    )

    observer.observe(productFormContentRef.current)

    return () => {
      observer.disconnect()
    }
  }, [])

  return (
    <div
      className={classNames(styles.productDescription__wrapper, styles.productDescription__wrapper__updatedDesignV2, {
        [styles.showReadMoreInDesc ?? '']: showReadMoreInDesc,
      })}
    >
      <div
        className={classNames(styles.productDescription__content, styles.productDescription__content__updatedDesignV2)}
        ref={productFormContentRef}
        //eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: getSanitizedHtml(productDescription),
        }}
      />
      <ProductDetailsIconSection
        icons={productDetailsIcons}
        wrapperClassName={styles.productDescription__iconsWrapper}
      />
    </div>
  )
}
